import { useAuth } from '../../context/auth-context';
import type { UIModule } from '../../core/types/permissions.types';

const EXCLUDED_MODULES = ['call', 'send_email'] as const;

export function usePermissions() {
  const { permissions } = useAuth();

  const getModulePerms = (module: UIModule) => {
    if ((EXCLUDED_MODULES as readonly string[]).includes(module)) return null;
    return permissions.find((p) => p.module === module) ?? null;
  };

  const canView = (module: UIModule): boolean =>
    getModulePerms(module)?.can_view ?? false;

  const canCreate = (module: UIModule): boolean =>
    getModulePerms(module)?.can_create ?? false;

  const canEdit = (module: UIModule): boolean =>
    getModulePerms(module)?.can_edit ?? false;

  const canDelete = (module: UIModule): boolean =>
    getModulePerms(module)?.can_delete ?? false;

  const hasFullAccess = (): boolean =>
    (['users', 'roles', 'devices'] as UIModule[]).every((m) => canView(m));

  return { canView, canCreate, canEdit, canDelete, hasFullAccess };
}
